import React, { Component } from "react";
import "./style.css";
import "../../../../../index.css";
class TrinityConditionLevel extends Component {
  render() {
    const { levelCondition, handleChooseLevel } = this.props;
    return (
      <div className="trinityConditionLevel_box">
        <img
          alt=""
          src={require("../../../../../images/trinity/subject_level.png")}
        ></img>
        <div className="trinityConditionLevel_sl_box">
          <div className="fl trinityConditionLevel_sl_left_box"></div>
          <div className="fl trinityConditionLevel_sl_right_box">
            <div className="fl font_size_15 color_5d5d5d line_height_19">
              语文
            </div>
            <div className="fl trinityConditionLevel_sl_right_level_box">
              <div
                onClick={() => handleChooseLevel("语文", "A")}
                className={
                  levelCondition["语文"] === "A"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                A
              </div>
              <div
                onClick={() => handleChooseLevel("语文", "B")}
                className={
                  levelCondition["语文"] === "B"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                B
              </div>
              <div
                onClick={() => handleChooseLevel("语文", "C")}
                className={
                  levelCondition["语文"] === "C"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                C
              </div>
              <div
                onClick={() => handleChooseLevel("语文", "D")}
                className={
                  levelCondition["语文"] === "D"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                D
              </div>
              <div
                onClick={() => handleChooseLevel("语文", "E")}
                className={
                  levelCondition["语文"] === "E"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                E
              </div>
            </div>
          </div>
        </div>
        <div className="trinityConditionLevel_sl_box major_top_20">
          <div className="fl trinityConditionLevel_sl_left_box"></div>
          <div className="fl trinityConditionLevel_sl_right_box">
            <div className="fl font_size_15 color_5d5d5d line_height_19">
              数学
            </div>
            <div className="fl trinityConditionLevel_sl_right_level_box">
              <div
                onClick={() => handleChooseLevel("数学", "A")}
                className={
                  levelCondition["数学"] === "A"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                A
              </div>
              <div
                onClick={() => handleChooseLevel("数学", "B")}
                className={
                  levelCondition["数学"] === "B"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                B
              </div>
              <div
                onClick={() => handleChooseLevel("数学", "C")}
                className={
                  levelCondition["数学"] === "C"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                C
              </div>
              <div
                onClick={() => handleChooseLevel("数学", "D")}
                className={
                  levelCondition["数学"] === "D"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                D
              </div>
              <div
                onClick={() => handleChooseLevel("数学", "E")}
                className={
                  levelCondition["数学"] === "E"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                E
              </div>
            </div>
          </div>
        </div>
        <div className="trinityConditionLevel_sl_box major_top_20">
          <div className="fl trinityConditionLevel_sl_left_box"></div>
          <div className="fl trinityConditionLevel_sl_right_box">
            <div className="fl font_size_15 color_5d5d5d line_height_19">
              外语
            </div>
            <div className="fl trinityConditionLevel_sl_right_level_box">
              <div
                onClick={() => handleChooseLevel("外语", "A")}
                className={
                  levelCondition["外语"] === "A"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                A
              </div>
              <div
                onClick={() => handleChooseLevel("外语", "B")}
                className={
                  levelCondition["外语"] === "B"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                B
              </div>
              <div
                onClick={() => handleChooseLevel("外语", "C")}
                className={
                  levelCondition["外语"] === "C"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                C
              </div>
              <div
                onClick={() => handleChooseLevel("外语", "D")}
                className={
                  levelCondition["外语"] === "D"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                D
              </div>
              <div
                onClick={() => handleChooseLevel("外语", "E")}
                className={
                  levelCondition["外语"] === "E"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                E
              </div>
            </div>
          </div>
        </div>
        <div className="trinityConditionLevel_sl_box major_top_20">
          <div className="fl trinityConditionLevel_sl_left_box"></div>
          <div className="fl trinityConditionLevel_sl_right_box">
            <div className="fl font_size_15 color_5d5d5d line_height_19">
              政治
            </div>
            <div className="fl trinityConditionLevel_sl_right_level_box">
              <div
                onClick={() => handleChooseLevel("政治", "A")}
                className={
                  levelCondition["政治"] === "A"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                A
              </div>
              <div
                onClick={() => handleChooseLevel("政治", "B")}
                className={
                  levelCondition["政治"] === "B"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                B
              </div>
              <div
                onClick={() => handleChooseLevel("政治", "C")}
                className={
                  levelCondition["政治"] === "C"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                C
              </div>
              <div
                onClick={() => handleChooseLevel("政治", "D")}
                className={
                  levelCondition["政治"] === "D"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                D
              </div>
              <div
                onClick={() => handleChooseLevel("政治", "E")}
                className={
                  levelCondition["政治"] === "E"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                E
              </div>
            </div>
          </div>
        </div>
        <div className="trinityConditionLevel_sl_box major_top_20">
          <div className="fl trinityConditionLevel_sl_left_box"></div>
          <div className="fl trinityConditionLevel_sl_right_box">
            <div className="fl font_size_15 color_5d5d5d line_height_19">
              历史
            </div>
            <div className="fl trinityConditionLevel_sl_right_level_box">
              <div
                onClick={() => handleChooseLevel("历史", "A")}
                className={
                  levelCondition["历史"] === "A"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                A
              </div>
              <div
                onClick={() => handleChooseLevel("历史", "B")}
                className={
                  levelCondition["历史"] === "B"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                B
              </div>
              <div
                onClick={() => handleChooseLevel("历史", "C")}
                className={
                  levelCondition["历史"] === "C"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                C
              </div>
              <div
                onClick={() => handleChooseLevel("历史", "D")}
                className={
                  levelCondition["历史"] === "D"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                D
              </div>
              <div
                onClick={() => handleChooseLevel("历史", "E")}
                className={
                  levelCondition["历史"] === "E"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                E
              </div>
            </div>
          </div>
        </div>
        <div className="trinityConditionLevel_sl_box major_top_20">
          <div className="fl trinityConditionLevel_sl_left_box"></div>
          <div className="fl trinityConditionLevel_sl_right_box">
            <div className="fl font_size_15 color_5d5d5d line_height_19">
              地理
            </div>
            <div className="fl trinityConditionLevel_sl_right_level_box">
              <div
                onClick={() => handleChooseLevel("地理", "A")}
                className={
                  levelCondition["地理"] === "A"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                A
              </div>
              <div
                onClick={() => handleChooseLevel("地理", "B")}
                className={
                  levelCondition["地理"] === "B"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                B
              </div>
              <div
                onClick={() => handleChooseLevel("地理", "C")}
                className={
                  levelCondition["地理"] === "C"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                C
              </div>
              <div
                onClick={() => handleChooseLevel("地理", "D")}
                className={
                  levelCondition["地理"] === "D"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                D
              </div>
              <div
                onClick={() => handleChooseLevel("地理", "E")}
                className={
                  levelCondition["地理"] === "E"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                E
              </div>
            </div>
          </div>
        </div>
        <div className="trinityConditionLevel_sl_box major_top_20">
          <div className="fl trinityConditionLevel_sl_left_box"></div>
          <div className="fl trinityConditionLevel_sl_right_box">
            <div className="fl font_size_15 color_5d5d5d line_height_19">
              物理
            </div>
            <div className="fl trinityConditionLevel_sl_right_level_box">
              <div
                onClick={() => handleChooseLevel("物理", "A")}
                className={
                  levelCondition["物理"] === "A"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                A
              </div>
              <div
                onClick={() => handleChooseLevel("物理", "B")}
                className={
                  levelCondition["物理"] === "B"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                B
              </div>
              <div
                onClick={() => handleChooseLevel("物理", "C")}
                className={
                  levelCondition["物理"] === "C"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                C
              </div>
              <div
                onClick={() => handleChooseLevel("物理", "D")}
                className={
                  levelCondition["物理"] === "D"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                D
              </div>
              <div
                onClick={() => handleChooseLevel("物理", "E")}
                className={
                  levelCondition["物理"] === "E"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                E
              </div>
            </div>
          </div>
        </div>
        <div className="trinityConditionLevel_sl_box major_top_20">
          <div className="fl trinityConditionLevel_sl_left_box"></div>
          <div className="fl trinityConditionLevel_sl_right_box">
            <div className="fl font_size_15 color_5d5d5d line_height_19">
              化学
            </div>
            <div className="fl trinityConditionLevel_sl_right_level_box">
              <div
                onClick={() => handleChooseLevel("化学", "A")}
                className={
                  levelCondition["化学"] === "A"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                A
              </div>
              <div
                onClick={() => handleChooseLevel("化学", "B")}
                className={
                  levelCondition["化学"] === "B"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                B
              </div>
              <div
                onClick={() => handleChooseLevel("化学", "C")}
                className={
                  levelCondition["化学"] === "C"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                C
              </div>
              <div
                onClick={() => handleChooseLevel("化学", "D")}
                className={
                  levelCondition["化学"] === "D"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                D
              </div>
              <div
                onClick={() => handleChooseLevel("化学", "E")}
                className={
                  levelCondition["化学"] === "E"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                E
              </div>
            </div>
          </div>
        </div>
        <div className="trinityConditionLevel_sl_box major_top_20">
          <div className="fl trinityConditionLevel_sl_left_box"></div>
          <div className="fl trinityConditionLevel_sl_right_box">
            <div className="fl font_size_15 color_5d5d5d line_height_19">
              生物
            </div>
            <div className="fl trinityConditionLevel_sl_right_level_box">
              <div
                onClick={() => handleChooseLevel("生物", "A")}
                className={
                  levelCondition["生物"] === "A"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                A
              </div>
              <div
                onClick={() => handleChooseLevel("生物", "B")}
                className={
                  levelCondition["生物"] === "B"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                B
              </div>
              <div
                onClick={() => handleChooseLevel("生物", "C")}
                className={
                  levelCondition["生物"] === "C"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                C
              </div>
              <div
                onClick={() => handleChooseLevel("生物", "D")}
                className={
                  levelCondition["生物"] === "D"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                D
              </div>
              <div
                onClick={() => handleChooseLevel("生物", "E")}
                className={
                  levelCondition["生物"] === "E"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                E
              </div>
            </div>
          </div>
        </div>
        <div className="trinityConditionLevel_sl_box major_top_20 major_bottom_15">
          <div className="fl trinityConditionLevel_sl_left_box"></div>
          <div className="fl trinityConditionLevel_sl_right_box">
            <div className="fl font_size_15 color_5d5d5d line_height_19">
              技术
            </div>
            <div className="fl trinityConditionLevel_sl_right_level_box">
              <div
                onClick={() => handleChooseLevel("技术", "A")}
                className={
                  levelCondition["技术"] === "A"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                A
              </div>
              <div
                onClick={() => handleChooseLevel("技术", "B")}
                className={
                  levelCondition["技术"] === "B"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                B
              </div>
              <div
                onClick={() => handleChooseLevel("技术", "C")}
                className={
                  levelCondition["技术"] === "C"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                C
              </div>
              <div
                onClick={() => handleChooseLevel("技术", "D")}
                className={
                  levelCondition["技术"] === "D"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                D
              </div>
              <div
                onClick={() => handleChooseLevel("技术", "E")}
                className={
                  levelCondition["技术"] === "E"
                    ? "fl trinityConditionLevel_level_active"
                    : "fl "
                }
              >
                E
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TrinityConditionLevel;



// WEBPACK FOOTER //
// ./src/containers/Trinity/TrinityCondition/components/TrinityConditionLevel/index.js